import React, { FC, useState } from "react";

import { TextField } from "@mui/material";

type CreateFolderStepProps = {
  folderPath: string;
  onChangeCallback: (_e: React.ChangeEvent<HTMLInputElement>) => boolean;
  onKeyDownCallback?: (_e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const CreateFolderStep: FC<CreateFolderStepProps> = ({
  folderPath,
  onChangeCallback,
  onKeyDownCallback,
}): JSX.Element => {
  const [error, setError] = useState<boolean>(false);
  return (
    <TextField
      slotProps={{
        inputLabel: {
          shrink: false,
        },
        htmlInput: {
          "data-testid": "inputFolderName",
        },
      }}
      name="folderName"
      value={folderPath}
      onKeyDown={onKeyDownCallback}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setError(onChangeCallback(e));
      }}
      fullWidth
      variant="outlined"
      placeholder="Enter folder name"
      error={error}
      helperText={error ? "Folder name already exists" : ""}
    />
  );
};

export default CreateFolderStep;
